export default __webpack_public_path__ + "static/media/focus3big_thumb.8c6e5988.jpg";